<template>
  <div
    ref="modalEl"
    class="modal fade"
    tabindex="-1"
    aria-labelledby="priceRejectTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="priceRejectTitle">Preisanfrage ablehnen</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Schließen"></button>
        </div>
        <div class="modal-body">
          <p v-if="item" class="reject-intro">
            <strong>{{ item.stock_number }}</strong> · {{ item.description }}<br />
            {{ item.servicepartner.description }} fragt
            <strong>{{ item.cost.price_request?.amount_label }}</strong>
            statt {{ item.cost.reference_price === null ? 'keinem hinterlegten Preis' : item.cost.reference_price_label }} an.
          </p>
          <label class="form-label" for="price-reject-note">Begründung (optional, steht in der Mail an den Partner)</label>
          <textarea
            id="price-reject-note"
            v-model="note"
            class="form-control"
            rows="4"
            maxlength="2000"
            placeholder="z. B. Preis liegt über unserer Obergrenze für dieses Fehlerbild."
          ></textarea>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Abbrechen</button>
          <button type="button" class="btn btn-danger" @click="onConfirm">Ablehnen</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, useTemplateRef } from 'vue';
import { Modal } from 'bootstrap';
import type { PriceRequest } from '../services/priceRequests';

/**
 * Absage einer Preisanfrage mit optionaler Begründung.
 *
 * `open(item)` löst mit der Begründung (Text oder null) auf, wenn abgelehnt
 * wurde — und mit `undefined`, wenn abgebrochen. Aufgelöst wird erst im
 * `hidden`-Event, damit ein Folge-Modal keinen Backdrop übernimmt.
 */

const modalEl = useTemplateRef<HTMLDivElement>('modalEl');
let   modal: Modal | null = null;
let   resolver: ((note: string | null | undefined) => void) | null = null;
let   ergebnis: string | null | undefined = undefined;

const item = ref<PriceRequest | null>(null);
const note = ref('');

onMounted(() => {
  if (modalEl.value) {
    modal = new Modal(modalEl.value);
    modalEl.value.addEventListener('hidden.bs.modal', onHidden);
  }
});

onBeforeUnmount(() => {
  modalEl.value?.removeEventListener('hidden.bs.modal', onHidden);
  modal?.dispose();
  modal = null;
});

function open(request: PriceRequest): Promise<string | null | undefined> {
  item.value = request;
  note.value = '';
  ergebnis   = undefined;
  return new Promise(resolve => {
    resolver = resolve;
    modal?.show();
  });
}

function onConfirm(): void {
  ergebnis = note.value.trim() === '' ? null : note.value.trim();
  modal?.hide();
}

function onHidden(): void {
  resolver?.(ergebnis);
  resolver = null;
}

defineExpose({ open });
</script>

<style scoped>
.reject-intro {
  margin-bottom: 0.9rem;
}
</style>
